import axios from 'axios';
import  router from '@/router';
import { Message } from 'element-ui';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // API接口的基础路径
  timeout: 15000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 可以在这里统一设置token
    const token = localStorage.getItem('auth-token') || sessionStorage.getItem('auth-token');
    if (token) {
      config.headers['auth-token'] = token;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  
  response => {

     const { config } = response;
     //alert('ss:'+JSON.stringify(config));
     //const callbacks = config.success;
    // 对响应数据做点什么
     const res = response.data;
    
    // 这里可以根据你的后端返回结构进行调整
    // 假设后端返回格式为 { code: 200, data: {}, message: 'success' }
    if (res.code && res.code !== 200) {
      // 业务错误处理
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject(new Error(res.message || 'Error'));
    } else {

      // 成功回调
    if (config.onSuccess) {
      config.onSuccess(res, response);
    }

      //alert(JSON.stringify(res));
      return res;
    }
  },
  error => {
    const { config } = error;
    // 对响应错误做点什么
    //console.error('Response error:', error);
    
    // HTTP状态码错误处理
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Message({
            message: '未授权，请重新登录',
            type: 'error',
            duration: 5 * 1000
          });
          // 可以在这里跳转到登录页
          // router.push('/login');
           router.push('/Login');
          break;
        case 403:
          Message({
            message: '拒绝访问',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 404:
          Message({
            message: '请求地址不存在',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 500:
          Message({
            message: '服务器内部错误',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 502:
          Message({
            message: '网关错误',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 503:
          Message({
            message: '服务不可用',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        case 504:
          Message({
            message: '服务请求超时，请稍后再试',
            type: 'error',
            duration: 5 * 1000
          });
          break;
        default:
          Message({
            message: error.response.data.message || '请求失败',
            type: 'error',
            duration: 5 * 1000
          });
      }
    } else if (error.request) {
      // 请求发送但无响应
      Message({
        message: '网络异常，请检查网络连接',
        type: 'error',
        duration: 5 * 1000
      });
    } else {
      // 请求配置出错
      Message({
        message: error.message || '请求配置错误',
        type: 'error',
        duration: 5 * 1000
      });
    }
    
    const msgData = error.response.data;
     if (config.onError) {
      config.onError(msgData);
    }

    return Promise.reject(error);
  }
);

// 创建请求方法（支持回调）
const createRequest = (callback = null) => {
  return new Promise((resolve, reject) => {
    service(config)
      .then(response => {
        // 如果有回调函数，执行回调
        if (callback && typeof callback === 'function') {

          callback(response); //第二个是数据
        }
        resolve(response);
      })
      .catch(error => {
        // 统一错误处理
        let errorMessage = '请求失败';
        let shouldShowMessage = true;
        
        if (error.response) {
          // HTTP状态码错误处理
          switch (error.response.status) {
            case 401:
              errorMessage = '未授权，请重新登录';
              Message({
                message: errorMessage,
                type: 'error',
                duration: 5 * 1000
              });
              router.push('/Login');
              shouldShowMessage = false; // 已经显示过
              break;
            case 403:
              errorMessage = '拒绝访问';
              break;
            case 404:
              errorMessage = '请求地址不存在';
              break;
            case 500:
              errorMessage = '服务器内部错误';
              break;
            case 502:
              errorMessage = '网关错误';
              break;
            case 503:
              errorMessage = '服务不可用';
              break;
            default:
              errorMessage = error.response.message;
          }
        } else if (error.request) {
          // 请求发送但无响应
          errorMessage = '网络异常，请检查网络连接';
        } else {
          // 请求配置出错
          errorMessage = error.message || '请求配置错误';
        }
        
        // 显示错误消息
        if (shouldShowMessage && errorMessage) {
          Message({
            message: errorMessage,
            type: 'error',
            duration: 5 * 1000
          });
        }
        
        // 处理业务错误（从响应拦截器传递过来的）
        if (error.message && error.message !== 'Error' && shouldShowMessage) {
          Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
          });
        }


      });
  });
};


export default service;


// WEBPACK FOOTER //
// ./src/utils/axiosConfig.js